export const LOCALE_PREFIX = 'scenes.Gnosus.components.EntityStack.components.TabBar.components.Tab'
